export default __webpack_public_path__ + "static/media/1529.cce9f889.png";